import React, { useEffect } from 'react'

interface BeforeInstallPromptEvent extends Event {
    readonly platforms: Array<string>
    readonly userChoice: Promise<{
        outcome: 'accepted' | 'dismissed'
        platform: string
    }>
    prompt(): Promise<void>
}

/**
 * Triggers native Android app install prompt
 * https://developer.chrome.com/blog/app-install-banners-native
 */
export const GoogleNativeAppPrompt: React.FC = () => {
    const onBeforeInstallPrompt = (e: BeforeInstallPromptEvent) => {
        if (typeof window !== undefined) {
            e.preventDefault()
            const deferredPrompt = e
            deferredPrompt.prompt()
        }
    }

    useEffect(() => {
        if (typeof window !== 'undefined') {
            window.addEventListener(
                'beforeinstallprompt',
                onBeforeInstallPrompt as EventListener,
            )
        }
    }, [])

    return <></>
}
